import {
  SpotlightFormSchema,
  SpotlightTriggerType,
} from "@redotech/redo-spotlight-common/spotlight-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getSpotlight = {
  name: "getSpotlight" as const,
  input: z.object({
    shopifyCustomerId: z.string().nullable(),
    customerHash: z.string(),
    isOnMobile: z.boolean(),
    currentUrl: z.string(),
    forceId: z.string().optional(),
    triggerType: createEnum(SpotlightTriggerType).optional(),
    // Shopper's country (ISO code) for geo-targeting eligibility.
    country: z.string().optional(),
  }),
  output: z.object({
    spotlight: SpotlightFormSchema.nullable(),
    spotlightId: z.string().nullable(),
    treatmentId: z.string().nullable(),
    skipPhoneSteps: z.boolean(),
    merchantPhoneNumber: z.string().optional(),
    reason: z.string().optional(),
  }),
};
